import React, { Component } from 'react';
import Modal from "react-responsive-modal";
import {isGamiclub} from './../../constants/isGamiclub'

const VideoModal=({url,onCloseModal,isModalOpen,title, poster})=>{
    let customStyles={
        customModal:{
            background:'black'
        }
    }

    return(
            <Modal open={isModalOpen} onClose={onCloseModal}
            classNames={{
                modal: !isGamiclub ? "customModal" : "customModalGamiclub",
                closeButton:!isGamiclub ? "customCloseButton" : "customCloseButtonGamiclub",
                closeIcon:"customCloseIcon"
              }}
             onOverlayClick={onCloseModal} center>
                <div className="wallpaperPreview">
                    <h3 style={{color: 'white'}}>{title}</h3>
                    <video style={{maxWidth: '640px', height: 'auto'}} poster={poster} controls  disablePictureInPicture>
                        <source src={url} type="video/mp4" />
                        Your browser does not support HTML5 Video
                    </video>
                </div>
            </Modal>
    )
}
export default VideoModal;


// WEBPACK FOOTER //
// ./src/components/UploadVideos/VideoModal.js